(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Lockton",
                {
                    url: "/Lockton",
                    component: "lockton",
                    PageTitle: "Lockton",
                    requiredPermissions: "Lockton:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("lockton",
        {
            templateUrl: "App/Resources/Lockton/lockton.html",
            controller: locktonCtrl,
            bindings: {
                states: "<"
            }
        });

    locktonCtrl.$inject = ["amplitudeService"];

    function locktonCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
    }
})(window.app, window.angular); // jshint ignore:line